import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const painPoints = ['Llevás el registro de tus pacientes en cuadernos o papeles sueltos', 'Perdés horas armando planes alimentarios desde cero para cada paciente', 'No tenés seguimiento objetivo del peso y medidas corporales', 'Las obras sociales te piden documentación y no tenés nada estandarizado', 'No tenés consentimientos informados ni anamnesis profesional', 'La imagen de tu consultorio no refleja tu nivel profesional'];
export function PainPoints() {
  return <section className="py-20 bg-gray-50" data-id="element-181">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-182">
        <div className="text-center mb-12" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-184">
            ¿Te está pasando esto?
          </h2>
        </div>

        <div className="grid gap-4 md:grid-cols-2" data-id="element-185">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-186">
              <div className="flex-shrink-0 mt-1" data-id="element-187">
                <div className="bg-red-100 p-1.5 rounded-full" data-id="element-188">
                  <X className="text-red-600" size={20} data-id="element-189" />
                </div>
              </div>
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-190">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}